import React, { useState } from "react";
import {
  MdFormatAlignLeft,
  MdFormatAlignRight,
  MdFormatAlignCenter,
} from "react-icons/md";
import { useSelector } from "react-redux";
import { getL1SheetProperty } from "../../../WorkbookSlice";

export default function TextAlignment({
  currentSheet,
  ControllerProps,
  dispatchItemToredux,
}) {
  const customizationObject = useSelector((state) =>
    getL1SheetProperty(state, currentSheet.Sheetid, "customization")
);
const { title, reduxKey, defaultValue } = ControllerProps;
  const reduxRowAlignment =
    customizationObject.rowAlign !== undefined
      ? customizationObject.rowAlign
      : defaultValue;
  const reduxValueAlignment =
    customizationObject.valueAlign !== undefined
      ? customizationObject.valueAlign
      : defaultValue;
  const [rowTextAlign, setRowTextAlign] = useState(reduxRowAlignment);
  const [valueTextAlign, setValueTextAlign] = useState(reduxValueAlignment);

  const handleAlignment = (value) => {
    if (reduxKey === "rowAlign") {
      setRowTextAlign(value);
      dispatchItemToredux(value, "rowAlign");
    } else {
      setValueTextAlign(value);
      dispatchItemToredux(value, "valueAlign");
    }
  };

  // Determine the active alignment based on reduxKey
  const activeAlign = reduxKey === "rowAlign" ? rowTextAlign : valueTextAlign;

  return (
    <div className="h-full items-center justify-center flex w-[14rem]">
      <div className="h-full w-full items-center justify-center mb-2 flex flex-col gap-y-2">
        {/* Align Section */}
        <div className="w-full items-center flex gap-x-[22.7%]">
          <span className="font-light text-sm pl-1">{title}</span>
          <button
            className={`w-auto flex items-center justify-center ${
              reduxKey === "rowAlign" ? "relative left-[0.4rem]" : ""
            }`}
          >
            <MdFormatAlignLeft
              className={`font-light cursor-pointer border border-gray-300 p-[1px] text-[140%] ${
                activeAlign === "left"
                  ? "bg-gray-200 text-gray-800"
                  : "text-gray-400"
              }`}
              onClick={() => handleAlignment("left")}
            />
            <MdFormatAlignCenter
              className={`font-light cursor-pointer border border-l-0 border-r-0 border-gray-300 p-[1px] text-[140%] ${
                activeAlign === "center"
                  ? "bg-gray-200 text-gray-800"
                  : "text-gray-400"
              }`}
              onClick={() => handleAlignment("center")}
            />
            <MdFormatAlignRight
              className={`font-light cursor-pointer border border-gray-300 p-[1px] text-[140%] ${
                activeAlign === "right"
                  ? "bg-gray-200 text-gray-800"
                  : "text-gray-400"
              }`}
              onClick={() => handleAlignment("right")}
            />
          </button>
        </div>
      </div>
    </div>
  );
}
